import {memo, useEffect, useRef, useState} from "react";
import CopyText from "../copyText/copyText";
import CheckBox from "../checkbox/checkbox";
import Popover from "../popover/popover";
import { useAppSelector } from "redux-share/hooks";
import { sendFluentLog, shareDialogLog } from "../../../../../logs";
import { conditions, secondsToHMS, videoTag } from "helpers";
import { ConditionName, IShareDialogProps } from "interfaces";
import useOnClickOutside from "helpers/hooks/useOnClickOutside";
import { handlePopoverSizeInMiniPlayer } from "helpers/helpers";
import { shallowEqual } from 'react-redux'

const ShareDialog = ({ status, onClose, currentTime, markerId }: IShareDialogProps) => {

    const [hasStartTime, setHasStartTime] = useState<boolean>(!!markerId);

    useAppSelector(({ controller: { showMiniPlayer } }) => ({ showMiniPlayer }), shallowEqual);
    useAppSelector(({ videoData: { params, videoElementSizeInfo } }) => ({ params, videoElementSizeInfo }), shallowEqual);

    let url = window.location.href;
    if(url.includes("?")) {
        url = url.split("&t=", 1)[0];
        if (hasStartTime) url = `${url}&t=${(currentTime ? currentTime : 0).toFixed(0)}`;
    } else {
        if (hasStartTime) url = `${url}?t=${(currentTime ? currentTime : 0).toFixed(0)}`;
    }

    useEffect(() => {
        setHasStartTime(!!markerId); 
    },[markerId, status])

    const handleCloseModal = () => {
        onClose();
        setTimeout(() => setHasStartTime(false), 500)
    }

    const handleShare = async() => {
        sendFluentLog(shareDialogLog(videoTag().currentTime ? Number(videoTag().currentTime.toFixed(0)) : 0, hasStartTime, Number((currentTime ? currentTime : 0).toFixed(0)), markerId));
        navigator.share({ url });
        handleCloseModal();
    }
    const shareRef = useRef<any>(null)

    useOnClickOutside(shareRef, () => onClose());

    const share = (
        <div className="pl-flex pl-flex-col pl-gap-4" ref={shareRef}>
            <p className="pl-text-[14px] pl-font-medium">اشتراک گذاری</p>
            <div className="pl-flex pl-gap-3">
                <CopyText
                    isJump={hasStartTime}
                    videoTime={Number((currentTime ? currentTime : 0).toFixed(0))}
                    markerId={markerId}
                    link={url}
                />
                <button className="pl-bg-secondary-200 dark:pl-bg-dark-1 pl-p-[13.33px] pl-rounded-[8px] pl-flex pl-items-center pl-gap-[2.28px]" onClick={handleShare}>
                    <span className="pl-w-[2.5px] pl-h-[2.5px] pl-bg-secondary-500 dark:pl-bg-secondary-50 pl-rounded-full"></span>
                    <span className="pl-w-[2.5px] pl-h-[2.5px] pl-bg-secondary-500 dark:pl-bg-secondary-50 pl-rounded-full"></span>
                    <span className="pl-w-[2.5px] pl-h-[2.5px] pl-bg-secondary-500 dark:pl-bg-secondary-50 pl-rounded-full"></span>
                </button>
            </div>
            <CheckBox
                label={`پرش به ${secondsToHMS(Number((currentTime ? currentTime : 0).toFixed(0)))}`}
                onChange={(value: boolean) => value ? setHasStartTime(true) : setHasStartTime(false)}
                labelClassName="pl-text-[14px] pl-font-medium"
                defaultValue={!!markerId}
            />
        </div>
    )

    return (
        <>
            <Popover
                status={status}
                onClose={handleCloseModal}
                isBlurBackground={!conditions(ConditionName.isMiniPlayer)}
                classNames={`pl-p-4 ${conditions(ConditionName.isMiniPlayer) && !conditions(ConditionName.isFullMobilePortrait) && `!pl-fixed pl-rounded-r-none opacity-100`}`}
                styles={{ width: conditions(ConditionName.isMiniPlayer) && !conditions(ConditionName.isFullMobilePortrait) ? 280 : 320, ...handlePopoverSizeInMiniPlayer() }}
                animation={conditions(ConditionName.isMiniPlayer) && !conditions(ConditionName.isFullMobilePortrait) ? (status ? "animate__fadeInLeft" : "animate__fadeOutLeft") : undefined}
                ref={shareRef}
                type={(conditions(ConditionName.isMiniPlayer) && !conditions(ConditionName.isFullMobilePortrait)) ? "popover" : "modal"}
            >
                {share}
            </Popover>
        </>
    )
}

export default memo(ShareDialog);